import { render, staticRenderFns } from "./project-list.vue?vue&type=template&id=21374ff6&scoped=true&"
import script from "./project-list.vue?vue&type=script&lang=js&"
export * from "./project-list.vue?vue&type=script&lang=js&"
import style0 from "./project-list.vue?vue&type=style&index=0&id=21374ff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21374ff6",
  null
  
)

export default component.exports